
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"56","height":"56"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#252626","d":"M51.333 14v5.833c0 .645-.522 1.167-1.166 1.167h-2.334a1.166 1.166 0 01-1.166-1.167V14h-5.834a1.166 1.166 0 01-1.166-1.167V10.5c0-.644.522-1.167 1.166-1.167h5.834A4.667 4.667 0 0151.333 14zm-35-3.5c0-.644-.522-1.167-1.166-1.167H9.333A4.667 4.667 0 004.667 14v5.833c0 .645.522 1.167 1.166 1.167h2.334c.644 0 1.166-.522 1.166-1.167V14h5.834c.644 0 1.166-.522 1.166-1.167V10.5zM50.167 35h-2.334c-.644 0-1.166.522-1.166 1.167V42h-5.834c-.644 0-1.166.522-1.166 1.167V45.5c0 .644.522 1.167 1.166 1.167h5.834A4.667 4.667 0 0051.333 42v-5.833c0-.645-.522-1.167-1.166-1.167zm-33.834 8.167c0-.645-.522-1.167-1.166-1.167H9.333v-5.833c0-.645-.522-1.167-1.166-1.167H5.833c-.644 0-1.166.522-1.166 1.167V42a4.667 4.667 0 004.666 4.667h5.834c.644 0 1.166-.523 1.166-1.167v-2.333z"}})])
          )
        }
      }
    